module.exports = __webpack_public_path__ + "static/lawrence-89ea19cf695169f274177b6610247107.jpg";